import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import { useEffect, useState } from "react";
import { requestGetStudentsEnrolledEvent } from "services/events/aboutEvents";
import useMainContext from "utils/context/useMainContext";

const useStudentTransfer = () => {

    const loadingRequest = useLoadingRequest();
    const [studentsEnrolled, setEstudentsEnrolled] = useState([]);

    async function fetchStudentsEnrolled(eventData){
        if(!loadingRequest){
            return []
        }
        const eventId = eventData.id;
        loadingRequest.show();
        try{
            const response = await requestGetStudentsEnrolledEvent(eventId);
            if(response == null){
                return []
                
            }
            
            setEstudentsEnrolled(response);
        } catch(err){
            return []
            // mainContext.setShowDialogUnexpectedError(true);
        } finally {
            
            // loadin
            // gRequest.hide();
        }
    }

    return {
        value: studentsEnrolled,
        fetchStudentsEnrolled,
    };
}

export default useStudentTransfer;